import "./modal.css";
import close from "../../assets/svgs/close.svg";
import { ButtonGeneric } from "../ButtonGeneric/buttonGeneric";

interface ModalProps {
  titleModal?: string;
  titleDescription?: string;
  titleDescriptions?: string;
  bodyModal?: any;
  buttonOne?: string;
  buttonTwo?: string;
  buttonThree?: string;
  buttonFour?: string;
  onClose?: () => void;
  onConfirm?: () => void;
  className?: string;
  classNameTwo?: string;
  isSubmitting?: boolean;
  classNameAux?: string;
  children?: React.ReactNode;
}

export const Modal = ({
  titleModal,
  titleDescription,
  titleDescriptions,
  bodyModal,
  buttonOne,
  buttonTwo,
  onClose,
  onConfirm,
  className,
  isSubmitting,
  classNameTwo,
  classNameAux,
  buttonThree,
  buttonFour,
  children,
}: ModalProps) => {
  return (
    <div className={`modalCorporate ${className}`}>
      <div className="modal">
        <div className={classNameTwo}>
          <div className="containerTitleModal">
            {titleModal && <h1 className="titleModal">{titleModal}</h1>}
            <button
              type="button"
              onClick={onClose}
              aria-label="Fechar modal"
              className="closeButton"
            >
              <img
                src={close}
                alt="icon close"
                width={15}
                height={15}
                style={{ cursor: "pointer" }}
              />
            </button>
          </div>

          <div className="containerDescription">
            {titleDescription && (
              <span className="titleDescription">{titleDescription}</span>
            )}
            {titleDescriptions && (
              <span className="titleDescriptions">{titleDescriptions}</span>
            )}

            {/* 🔽 Aqui: mantém compatibilidade com bodyModal, mas dá suporte a children */}
            {bodyModal ? (
              <span className="bodyModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            ) : (
              children
            )}

            <div className="buttonsEdit">
              {buttonOne && (
                <ButtonGeneric
                  style="buttonGeneric buttonHover buttonGenericCustom tes"
                  title={buttonOne}
                  colorTitle="#fff"
                  onClick={onConfirm}
                  disabled={isSubmitting}
                />
              )}
              {buttonTwo && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonTwo}
                  colorTitle="#007BC0"
                  onClick={onClose}
                />
              )}
              {buttonThree && (
                <ButtonGeneric
                  style={`buttonGenericCustom ${classNameAux}`}
                  title={buttonThree}
                  colorTitle="#007BC0"
                  onClick={onClose}
                />
              )}
              {buttonFour && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonFour}
                  colorTitle="#007BC0"
                  onClick={onConfirm}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
